import { UpdateChannelRedirect } from '@/connection/channel/redirects';
import { ChannelRedirect } from '@/micros/homepage/settings/settings-main/components/channel-redirects';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const updateRedirectReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ redirect }: { redirect: ChannelRedirect }, { rejectWithValue }) => {
      try {
        const res = await UpdateChannelRedirect(redirect);
        return res;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.redirects) {
          state.redirects = state.redirects.map((redirect) =>
            redirect.id === action.payload.id ? action.payload : redirect
          );
        }
      },
    }
  );
};

export default updateRedirectReducer;
